import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  IconButton,
  Grid,
  InputLabel,
  TextField,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import DatePicker from "react-datepicker";
import CustomButton from "../../Custom/CustomButton";
import instance from "../../../globals/axios";
import { getFarmerPlotId } from "../../../globals/utils";
import { useAlert } from "../../Alert";
import EditIcon from "../../../assets/svg/EditIcon.svg";
import SuccessPopup from "./SuccessPopup";
import axios from "axios";
import { getAuth } from "../../../globals/authentication";
import { SERVER_BASE_ADDRESS } from "../../../globals/const";
import ImageCard from "../../ImagesDisplay";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    fontSize: 16,
  },
  dialogContent: {
    height: 400,
  },
  datepicker: {
    display: "none",
  },
  taxtLabel: {
    fontSize: "12px !important",
    fontFamily: "Inter",
    fontWeight: "400 !important",
    color: "#000",
    marginTop: "10px",
  },
  taxtTitle: {
    fontSize: "12px !important",
    fontFamily: "Inter",
    fontWeight: "700 !important",
    color: "#000",
  },
}));

const DehaulmingPopup = ({ onClose, t }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const user = getAuth();
  const { showAlert } = useAlert();
  const [existingData, setExistingData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [comment, setComment] = useState("");
  const [errors, setErrors] = useState({
    startDate: "",
    endDate: "",
    image: "",
  });
  let farmerPlotId = getFarmerPlotId();

  useEffect(() => {
    if (farmerPlotId) {
      const fetchData = async () => {
        try {
          const response = await instance(
            `plotengagement/get-dehaulsing?farmer_plot=${farmerPlotId}`
          );
          let data = response.data;
          if (data.data.length > 0) {
            setExistingData(data.data[0]);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData();
    }
  }, [farmerPlotId]);

  useEffect(() => {
    if (existingData) {
      const { start_date, end_date, images } = existingData;
      setStartDate(start_date ? new Date(start_date) : null);
      setEndDate(end_date ? new Date(end_date) : null);
      setComment(existingData.comments || "");
      if (images && images.length > 0) {
        setUploadedImages(images.map((img) => img.URL));
      }
    }
  }, [existingData]);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setErrors((prevErrors) => ({
      ...prevErrors,
      startDate: "",
    }));
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setErrors((prevErrors) => ({
      ...prevErrors,
      endDate: "",
    }));
  };

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    setUploadedImages((prevImages) => [...prevImages, ...files]);
    event.target.value = null;
    setErrors((prevErrors) => ({
      ...prevErrors,
      image: "",
    }));
  };

  const handleDeleteImage = (imageUrl) => {
    setUploadedImages((prevImages) =>
      prevImages.filter((url) => url !== imageUrl)
    );
  };

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const validateForm = () => {
    let formValid = true;
    let updatedErrors = {};

    if (!startDate) {
      updatedErrors = {
        ...updatedErrors,
        startDate: t("Please select a start date."),
      };
      formValid = false;
    }

    if (!endDate) {
      updatedErrors = {
        ...updatedErrors,
        endDate: t("Please select an end date."),
      };
      formValid = false;
    }

    if (uploadedImages.length === 0) {
      updatedErrors = {
        ...updatedErrors,
        image: t("Please upload at least one image."),
      };
      formValid = false;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      ...updatedErrors,
    }));

    return formValid;
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const handleSubmit = () => {
    const isFormValid = validateForm();
    if (isFormValid) {
      const formatDate = (date) => {
        const pad = (num) => (num < 10 ? `0${num}` : `${num}`);
        return date
          ? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
              date.getDate()
            )}`
          : null;
      };

      const formData = new FormData();
      formData.append("start_date", startDate ? formatDate(startDate) : null);
      formData.append("end_date", endDate ? formatDate(endDate) : null);

      uploadedImages.forEach((image) => {
        if (image instanceof File) {
          formData.append("images", image);
        }
      });

      if (comment) {
        formData.append("comments", comment);
      }

      if (isEditMode) {
        formData.append("id", existingData.id);
      } else {
        formData.append("farmer_plot", farmerPlotId);
      }

      const headers = {
        Authorization: `Token ${user.token}`,
        "Content-Type": "multipart/form-data",
      };

      const apiUrl = isEditMode
        ? "plotengagement/update-dehaulsing"
        : "plotengagement/create-dehaulsing";
      axios
        .post(`${SERVER_BASE_ADDRESS}/${apiUrl}`, formData, {
          headers,
        })
        .then((res) => {
          if (res?.data) {
            setShowSuccessPopup(true);
            setTimeout(() => {
              setShowSuccessPopup(false);
              onClose();
            }, 2000);
          }
        })
        .catch((err) => {
          console.error("Error in creating/updating dehaulsing", err);
          showAlert("error", "Some Error Occurred");
        });
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        style={{ zIndex: 1 }}
        PaperProps={{ style: { maxHeight: "calc(100% - 25%)" } }}
      >
        <div style={{ padding: "16px", height: "100%" }}>
          <Grid container>
            <Grid item xs={10}>
              <DialogTitle style={{ padding: "0px" }}>
                {t("Dehaulming")}
              </DialogTitle>
            </Grid>
            {existingData !== null ? (
              <Grid item xs={1} style={{ marginTop: "10px" }}>
                <img src={EditIcon} onClick={handleEditClick} alt="Edit" />
              </Grid>
            ) : null}
            <Grid item xs={1}>
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid container style={{ marginTop: "30px" }}>
              <Grid item xs={6} style={{ marginTop: "20px" }}>
                <InputLabel style={{ fontSize: "12px" }}>
                  {t("Start Date")}
                </InputLabel>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  placeholder="DD/MM/YYYY"
                  disabled={!isEditMode && existingData !== null}
                  fullWidth
                  value={startDate ? startDate.toLocaleDateString() : ""}
                  helperText={errors.startDate}
                  error={!!errors.startDate}
                  InputProps={{
                    sx: {
                      height: "40px",
                      borderRadius: "5px",
                      marginTop: "10px",
                      background: "#FFF",
                      border: "1px solid #C7BDBD",
                    },
                    readOnly: true,
                    onClick: () =>
                      document.getElementById("start-date-picker").click(),
                  }}
                />
                <DatePicker
                  id="start-date-picker"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={handleStartDateChange}
                  className={classes.datepicker}
                />
              </Grid>

              <Grid item xs={6} style={{ marginTop: "20px" }}>
                <InputLabel style={{ fontSize: "12px" }}>
                  {t("End Date")}
                </InputLabel>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  placeholder="DD/MM/YYYY"
                  disabled={!isEditMode && existingData !== null}
                  fullWidth
                  value={endDate ? endDate.toLocaleDateString() : ""}
                  helperText={errors.endDate}
                  error={!!errors.endDate}
                  InputProps={{
                    sx: {
                      height: "40px",
                      borderRadius: "5px",
                      marginTop: "10px",
                      background: "#FFF",
                      border: "1px solid #C7BDBD",
                    },
                    readOnly: true,
                    onClick: () =>
                      document.getElementById("end-date-picker").click(),
                  }}
                />
                <DatePicker
                  id="end-date-picker"
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={handleEndDateChange}
                  className={classes.datepicker}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.fileInput}>
              <InputLabel className={classes.textLabel}>
                {t("Upload Images")}
              </InputLabel>
              <input
                accept="image/*"
                style={{ display: "none" }}
                id="upload-image"
                type="file"
                multiple
                onChange={handleImageChange}
              />
              <label htmlFor="upload-image">
                <CustomButton hideIcon>{t("Upload")}</CustomButton>
              </label>
              {errors.image && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.image}
                </div>
              )}
            </Grid>
            <Box
              sx={{
                display: "flex",
                overflowX: "auto",
                marginTop: "20px",
                padding: 1,
              }}
            >
              {uploadedImages.map((image, index) => (
                <ImageCard
                  key={index}
                  imageUrl={
                    typeof image === "string"
                      ? image
                      : URL.createObjectURL(image)
                  }
                  onDelete={() => handleDeleteImage(image)}
                />
              ))}
            </Box>
            <Grid item xs={12} style={{ display: "grid", padding: "10px" }}>
              <InputLabel>{t("Comment(Optional)")}</InputLabel>
              <TextField
                multiline
                rows={1}
                value={comment}
                onChange={handleCommentChange}
                disabled={!isEditMode && existingData !== null}
              />
            </Grid>
          </Grid>
        </div>

        <div
          style={{ display: "flex", margin: "auto", justifyContent: "center" }}
        >
          {existingData && isEditMode ? (
            <div style={{ width: "140px" }}>
              <CustomButton onClick={handleSubmit} hideIcon>
                {t("Update")}
              </CustomButton>
            </div>
          ) : !existingData && !isEditMode ? (
            <div
              style={{
                display: "flex",
                margin: "auto",
                justifyContent: "center",
                width: "140px",
              }}
            >
              <CustomButton onClick={handleSubmit} hideIcon>
                {t("Submit")}
              </CustomButton>
            </div>
          ) : null}
        </div>

        {showSuccessPopup && <SuccessPopup />}
      </Dialog>
    </div>
  );
};

export default DehaulmingPopup;
